export default __webpack_public_path__ + "76d0d58e2d34bf9a83b88ef64884ff75.webp";